import React, { useState } from 'react'
import { Button, Result } from 'antd';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { VERIFY_ACCOUNT } from '../../Apollo/graphql/Mutation/VerifyAccount';

const ActivateAccountPage = () => {

  const history = useHistory();
  const [verifyAccountMutation] = useMutation(VERIFY_ACCOUNT);
  const [buttonLoading, setButtonLoading] = useState(false);

  const url = window.location.href;
  const token = url?.split('?')[1]?.split('=')[1];

  const onClick = async () => {
    setButtonLoading(true);
    try {
      const { data} = await verifyAccountMutation({
        variables: {
          input: {
            token: token
          }
        }
      })
      if(data){
        history.push('/signin')
      }
      setButtonLoading(false)
    } catch (err) {
      setButtonLoading(false)
    }

  }

  return (
    <div>
      <Result
        status="success"
        title="Successfully activated your account!"
        subTitle="click to verify your account"
        extra={[
          <Button type="primary" onClick={onClick} loading={buttonLoading}>
            verify account
          </Button>,
        ]}
      />
    </div>
  )
}

export default ActivateAccountPage;